import { connect } from "react-redux";
import { commonStyle } from "../../../../assets/css/css";
import { useEffect, useState } from "react";
import '../styles/CallPerformance.css';
import { HiRefresh } from "react-icons/hi";
import { toast } from "react-toastify";
import Topbar from "../../../../common/component/topbar/Topbar";
import Sidebar from "../../../../common/componentV2/sidebar/Sidebar";
import { GET } from "../../../../services/HttpRequests";
import DataCard from "../component/DataCard";

import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper
} from '@material-ui/core';

const moment = require('moment-timezone');
const todayDate = moment().tz('Asia/Kolkata').format('YYYY-MM-DD');
const organisationId = localStorage.getItem('doosra-biz-organisation-id');

const analyticsUrl = process.env.REACT_APP_ANALYTICS_API;

const AbstractTable = ({ columns, data }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="abstract table">
        <TableHead style={{ backgroundColor: "#f5f5f5" }}>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell key={index}><strong>{col.label}</strong></TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, i) => (
            <TableRow key={i}>
              {columns.map((col, index) => (
                <TableCell key={index}>{row[col.name]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const TableHeading = ({ title, refreshFunction }) => {
  return <div style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    color: "#000",
    fontSize: "18px",
    fontWeight: "bold",
  }}>
    {title}
    <div style={{ cursor: "pointer", color: '#34C759', fontSize: "16px" }} onClick={refreshFunction}><HiRefresh /></div>
  </div>;
}

const LoaderComponent = () => {
  return <div style={{ color: '#196cca', fontSize: "16px", fontWeight: "bold" }} >
    <HiRefresh />&nbsp;Loading...
  </div>;
}

const NoDataFoundComponent = () => {
  return <div style={{ color: '#196cca', fontSize: "16px", fontWeight: "bold" }} >
    No data found
  </div>;
}

const latencyColumns = [{
  name: 'latencyRange', label: 'Latency Range (seconds)'
},
{ name: 'callCount', label: 'Call Count' },
{ name: 'percentage', label: 'Percentage' },
{ name: 'cumulativePercentage', label: 'Cumulative %' }
];

const callSuccessRateColumns = [{
  name: 'callStatus', label: 'Call Status'
},
{ name: 'count', label: 'Count' },
{ name: 'percentage', label: 'Percentage' },
];

const channelsUsageColumns = [{
  name: 'timeSlot', label: 'Time Slot'
},
{ name: 'totalCalls', label: 'Total Calls' },
{ name: 'concurrentCalls', label: 'Concurrent Calls' },
{ name: 'channelsUsed', label: 'Channels Used' },
{ name: 'cpsUsage', label: 'CPS Usage' }
];

const webhookDelayColumns = [{
  name: 'latencyRange', label: 'Delay Range (seconds)'
},
{ name: 'callCount', label: 'Call Count' },
{ name: 'percentage', label: 'Percentage' },
{ name: 'cumulativePercentage', label: 'Cumulative %' }
];

const webhookResponseDurationColumns = [{
  name: 'latencyRange', label: 'Duration Range (seconds)'
},
{ name: 'callCount', label: 'Call Count' },
{ name: 'percentage', label: 'Percentage' },
{ name: 'cumulativePercentage', label: 'Cumulative %' }
];

function CallPerformanceStats(props) {

  const [date, setDate] = useState(todayDate);

  const [avgLatency, setAvgLatency] = useState(0);
  const [totalCalls, setTotalCalls] = useState(0);
  const [totalSuccessfullCalls, setTotalSuccessfullCalls] = useState(0);
  const [callsUnder5s, setCallsUnder5s] = useState(0);

  const [latencyData, setLatencyData] = useState([]);
  const [callSuccessRateData, setCallSuccessRateData] = useState([]);
  const [channelUsageData, setChannelUsageData] = useState([]);
  const [webhookDelayData, setWebhookDelayData] = useState([]);
  const [webhookResponseDurationData, setWebhookResponseDurationData] = useState([]);

  const [latencyDataLoader, setLatencyDataLoader] = useState(false);
  const [callSuccessDataLoader, setCallSuccessDataLoader] = useState(false);
  const [channelsUsageDataLoader, setChannelsUsageDataLoader] = useState(false);
  const [webhookDelayDataLoader, setWebhookDelayDataLoader] = useState([]);
  const [webhookResponseDurationDataLoader, setWebhookResponseDurationDataLoader] = useState([]);

  useEffect(() => {
    fetchLatencyData();
    fetchCallSuccessRateData();
    fetchChannelUsageData();
    fetchWebhookDelayData();
    fetchWebhookResponseDurationData();
  }, []);

  const fetchLatencyData = async () => {
    try {
      setLatencyDataLoader(true);
      const response = await GET(analyticsUrl + `metrics/get-latency-metrics?organisationId=${organisationId}&date=${date}`);
      setLatencyData(response?.data?.response?.result || []);

      setAvgLatency(response?.data?.response?.avgLatency || 0);
      setCallsUnder5s(response?.data?.response?.callsUnder5s || 0);
      setTotalSuccessfullCalls(response?.data?.response?.totalCalls || 0);

      setLatencyDataLoader(false);
    } catch (error) {
      toast.error("Error fetching latency data");
      setLatencyDataLoader(false);
      setLatencyData([]);
      console.log(error);
    }
  }

  const fetchCallSuccessRateData = async () => {
    try {
      setCallSuccessDataLoader(true);
      const response = await GET(analyticsUrl + `metrics/get-call-success-metrics?organisationId=${organisationId}&date=${date}`);
      setCallSuccessRateData(response?.data?.response?.callSuccessData || []);

      setTotalCalls(response?.data?.response?.callData?.Totalcalls || 0);

      setCallSuccessDataLoader(false);
    } catch (error) {
      toast.error("Error fetching call success rate data");
      setCallSuccessDataLoader(false);
      setCallSuccessRateData([]);
      console.log(error);
    }
  }

  const fetchChannelUsageData = async () => {
    try {
      setChannelsUsageDataLoader(true);
      const response = await GET(analyticsUrl + `metrics/get-channel-usage-metrics?organisationId=${organisationId}&date=${date}`);
      setChannelUsageData(response?.data?.response || []);
      setChannelsUsageDataLoader(false);
    } catch (error) {
      toast.error("Error fetching channel usage data");
      setChannelsUsageDataLoader(false);
      setChannelUsageData([]);
      console.log(error);
    }
  }

  const fetchWebhookDelayData = async () => {
    try {
      setWebhookDelayDataLoader(true);
      const response = await GET(analyticsUrl + `metrics/get-webhook-delay-metrics?organisationId=${organisationId}&date=${date}`);
      setWebhookDelayData(response?.data?.response?.result || []);
      setWebhookDelayDataLoader(false);
    } catch (error) {
      toast.error("Error fetching webhook delay data");
      setWebhookDelayDataLoader(false);
      setWebhookDelayData([]);
      console.log(error);
    }
  }

  const fetchWebhookResponseDurationData = async () => {
    try {
      setWebhookResponseDurationDataLoader(true);
      const response = await GET(analyticsUrl + `metrics/get-webhook-response-duration-metrics?organisationId=${organisationId}&date=${date}`);
      setWebhookResponseDurationData(response?.data?.response?.result || []);
      setWebhookResponseDurationDataLoader(false);
    } catch (error) {
      toast.error("Error fetching webhook response duration data");
      setWebhookResponseDurationDataLoader(false);
      setWebhookResponseDurationData([]);
      console.log(error);
    }
  }

  const handleSearch = () => {
    fetchLatencyData();
    fetchCallSuccessRateData();
    fetchChannelUsageData();
    fetchWebhookDelayData();
    fetchWebhookResponseDurationData();
  }

  return (<div className={`${props.className}`}>
    <Topbar />
    <div style={{ display: 'flex', height: 'calc(100vh - 72px)' }}>
      <Sidebar />
      <div className="CallPerformancePageContainer">
        <div className='CallPerformance'>
          <div className='CallPerformanceHeader'>
            <div className='CallPerformanceHeading'>
              <div className='CallPerformanceName'>Call Performance stats</div>
              <div className='CallPerformanceDescription'>-</div>
            </div>
            <div className='CallPerformanceRefreshComponent'>
              <div className='CallPerformanceFilter'>
                <div className='CallPerformanceFilterHeader'>FILTER</div>
                <div>
                  <input
                    type="date"
                    className='CallPerformanceDateFilter'
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>
                <div>
                  <button
                    className="CallPerformanceFilterSearchButton"
                    onClick={handleSearch}
                  >
                    SEARCH
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="CallPerformanceDataCardsContainer">
            <DataCard
              title="Total Calls"
              count={totalCalls || 0}
            />
            <DataCard
              title="Call success rate (%)"
              count={totalCalls ? ((totalSuccessfullCalls / totalCalls) * 100).toFixed(2) : 0}
            />
            <DataCard
              title="Calls made under 5s"
              count={callsUnder5s || 0}
            />
            <DataCard
              title="Avg Latency"
              count={avgLatency || 0}
            />
          </div>

          {/* Inner Tab Area - Start */}
          <div className='CallPerformanceContainer'>
            <TableHeading title="Detailed Latency Breakdown" refreshFunction={fetchLatencyData} />
            {latencyDataLoader ?
              <LoaderComponent /> :
              latencyData?.length > 0 ?
                <AbstractTable
                  columns={latencyColumns || []}
                  data={latencyData || []}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          <div className='CallPerformanceContainer'>
            <TableHeading title="Call Success Rate Breakdown" refreshFunction={fetchCallSuccessRateData} />
            {callSuccessDataLoader ?
              <LoaderComponent /> :
              callSuccessRateData?.length > 0 ?
                <AbstractTable
                  columns={callSuccessRateColumns || []}
                  data={callSuccessRateData || []}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          <div className='CallPerformanceContainer'>
            <TableHeading title="Channel Usage & Traffic Analysis" refreshFunction={fetchChannelUsageData} />
            {channelsUsageDataLoader ?
              <LoaderComponent /> :
              channelUsageData?.length > 0 ?
                <AbstractTable
                  columns={channelsUsageColumns || []}
                  data={channelUsageData || []}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          <div className='CallPerformanceContainer'>
            <TableHeading title="Webhook Delay Metrics" refreshFunction={fetchWebhookDelayData} />
            {webhookDelayDataLoader ?
              <LoaderComponent /> :
              webhookDelayData?.length > 0 ?
                <AbstractTable
                  columns={webhookDelayColumns || []}
                  data={webhookDelayData || []}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          <div className='CallPerformanceContainer'>
            <TableHeading title="Webhook Response Duration" refreshFunction={fetchWebhookResponseDurationData} />
            {webhookResponseDurationDataLoader ?
              <LoaderComponent /> :
              latencyData?.length > 0 ?
                <AbstractTable
                  columns={webhookResponseDurationColumns || []}
                  data={webhookResponseDurationData || []}
                /> :
                <NoDataFoundComponent />
            }
          </div>

          {/* Inner Tab Area - End  */}
        </div>
      </div>
    </div>
  </div>);
}

const mapStateToProps = (state) => ({
  sidebarClosed: state.sidebar.sidebarClosed,
  userDetails: state.recovery.userDetails,
});

export default commonStyle(connect(mapStateToProps, {})(CallPerformanceStats));